import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './standalone.css';
const mountedRoots = new WeakMap();
export function mount(container, options = {}) {
    const existingRoot = mountedRoots.get(container);
    if (existingRoot) {
        existingRoot.unmount();
    }
    const root = createRoot(container);
    mountedRoots.set(container, root);
    root.render(_jsx(StrictMode, { children: _jsx(App, { appName: options.appName, basePath: options.basePath }) }));
    return {
        unmount: () => {
            root.unmount();
            mountedRoots.delete(container);
        },
    };
}
